import React from "react";
import { useParams } from "react-router-dom";
import CoverAndLogo from "./BrandingPages/CoverAndLogo/CoverAndLogo.js";
import BrandingHeaderPage from "./BrandingHeaderPage.js";
import BrandingEmail from "./BrandingPages/BrandingEmail/BrandingEmail.js";
import BussinessProfile from "./BrandingPages/BussinessProfile/BussinessProfile.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import "./Branding.scss";

const Branding = ({ userData }) => {
  const { getPath } = useContent();
  const params = useParams();
  const pageDetails = {
    "cover-logo": {
      pageTitle: "cover-logo-title",
      subtitle: "cover-logo-subtitle",
    },
    email: {
      pageTitle: "branding-email-title",
      subtitle: "branding-email-subtitle",
    },
    "business-profile": {
      pageTitle: "profile-menu-branding-bussiness-profile",
      subtitle: "bussiness-profile-subtitle",
    },
  };

  const renderPage = () => {
    switch (params.profilePage) {
      case "":
      case undefined:
      case "cover-logo":
        return <CoverAndLogo />;
      case "email":
        return <BrandingEmail />;
      case "business-profile":
        return <BussinessProfile />;
      default:
        break;
    }
  };

  return (
    <div className="user-branding-container">
      {params.profilePage && (
        <BrandingHeaderPage
          pageName={params.profilePage}
          pageTitle={pageDetails[params.profilePage].pageTitle}
          subtitle={pageDetails[params.profilePage].subtitle}
          subtitle2={pageDetails[params.profilePage].subtitle2}
        />
      )}
      {renderPage()}
    </div>
  );
};
export default Branding;
